export default __webpack_public_path__ + "files/1_3_3_1_POWER4BIO_Business_Modelling_Methodology.docx";